import ManualIntegrationForm from './ManualIntegrationForm';

export default ManualIntegrationForm;
export * from './ManualIntegrationForm';
